import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import api from '../../../../helpers/apiRequester'
import { Button, Card } from '../../../../ui'
export interface statsProps {
    data: any
}
export const ClientView = (props: statsProps) => {
    const { data } = props
    const [showStats, setShowStats] = useState(false)
    const [editing, setEditing] = useState(false)
    const [dataChanged, setDataChanged] = useState(false)
    const [clientData, setClientData] = useState(data)

    useEffect(() => {
        // console.log("DATAVIEW : ", data);
    }, [data])

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
    }

    const onChange = async (e: React.FormEvent<HTMLInputElement>) => {
        let tempClientData = { ...clientData }
        tempClientData[e.currentTarget.name] = e.currentTarget.value
        setClientData(tempClientData)
        setDataChanged(true)
    }

    const saveData = async () => {
        Loading.circle('Saving')
        console.log('SAVE DATA......')
        try {
            const apiResult = await api({
                url: 'pcp-sentinel/save-client-info',
                data: { clientDataToSave: clientData },
            })

            Loading.remove()
            if (!apiResult.data.success) return Report.failure('Error', 'An error occurred.', 'Okay')

            Report.success('Success', 'Your update saved successfully.', 'Okay')
            setEditing(false)
        } catch (error) {
            Report.failure('Error', 'An error occurred.', 'Okay')
        }
    }

    const handleEditToggle = () => {
        if (editing) setClientData(data)
        setEditing(!editing)
    }

    return (
        <Card
            className={styles.clientView}
            title="Client information"
            actions={
                <>
                    <Button size="sm" variant="neutral" onClick={() => handleEditToggle()}>
                        {editing ? 'Cancel' : 'Edit'}
                    </Button>
                    {editing && dataChanged ? (
                        <Button size="sm" variant="primary" onClick={() => saveData()}>
                            Save
                        </Button>
                    ) : null}
                </>
            }
        >
            <form onSubmit={(e) => handleSubmit(e)} className={styles.form}>
                <fieldset>
                    <label>First name</label>
                    <input
                        className={styles.textInput}
                        name={'firstname'}
                        value={clientData.firstname}
                        type="text"
                        onChange={onChange}
                        disabled={!editing}
                    />
                </fieldset>
                <fieldset>
                    <label>Last name</label>
                    <input
                        className={styles.textInput}
                        name={'lastname'}
                        value={clientData.lastname}
                        type="text"
                        onChange={onChange}
                        disabled={!editing}
                    />
                </fieldset>
                <fieldset>
                    <label>Title</label>
                    <input
                        className={styles.textInput}
                        name={'title'}
                        value={clientData.title}
                        type="text"
                        onChange={onChange}
                        disabled={!editing}
                    />
                </fieldset>
                <fieldset>
                    <label>Date of Birth</label>
                    <input
                        className={styles.textInput}
                        name={'dob'}
                        value={clientData.dob}
                        type="text"
                        onChange={onChange}
                        disabled={!editing}
                    />
                </fieldset>
                <fieldset>
                    <label>Email</label>
                    <input
                        className={styles.textInput}
                        name={'email'}
                        value={clientData.email}
                        type="text"
                        onChange={onChange}
                        disabled={!editing}
                    />
                </fieldset>
                <fieldset>
                    <label>Telephone</label>
                    <input
                        className={styles.textInput}
                        name={'phone'}
                        value={clientData.phone}
                        type="text"
                        onChange={onChange}
                        disabled={!editing}
                    />
                </fieldset>
                <div className={styles.formDiv}>
                    <h4>Client Address</h4>
                    <fieldset>
                        <label>Address line one</label>
                        <input
                            className={styles.textInput}
                            value={clientData.address_line_one}
                            name={'address_line_one'}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>
                    <fieldset>
                        <label>Address line two</label>
                        <input
                            className={styles.textInput}
                            name={'address_line_two'}
                            value={clientData.address_line_two}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>
                    <fieldset>
                        <label>Address line three</label>
                        <input
                            className={styles.textInput}
                            name={'address_line_three'}
                            value={clientData.address_line_three}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>
                    <fieldset>
                        <label>City</label>
                        <input
                            className={styles.textInput}
                            name={'city'}
                            value={clientData.city}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>
                    <fieldset>
                        <label>Postcode</label>
                        <input
                            className={styles.textInput}
                            name={'postcode'}
                            value={clientData.postcode}
                            type="text"
                            onChange={onChange}
                            disabled={!editing}
                        />
                    </fieldset>
                </div>
            </form>
        </Card>
    )
}
